 <template>
   <div class="form-title-wrap">
     <span class="line"></span>
     <span class="text"><span class="red" v-if="hasStar">*</span>{{title}}</span>
   </div>
 </template>
 
 <script>
 export default {
   props: {
     title: {
       type: String,
       default: ''
     },
     hasStar: {
       type: Boolean,
       default: false
     }
   }
 }
 </script>
 
 <style lang="stylus">
  .form-title-wrap
    width 100%
    padding 8px 0
    border-bottom 1px solid #007ab0
    .line
      display inline-block
      vertical-align middle
      width 10px
      height 14px
      border-left 2px solid #007ab0
    .text
      display inline-block
      vertical-align middle
      font-size 14px
      color #007ab0 
      font-weight bold 
      .red
        font-size 10px
        color #f03b3b 
 </style>


// WEBPACK FOOTER //
// src/components/form-title/form-title.vue